import API from '../index';
import { Order } from '../../types/common';

const getOrder = async (orderId: string): Promise<Order> => {
  const order: Order = await API.get(`/customer/transactions/${orderId}`);
  return order;
};

export default getOrder;
